export default {
  name: 'dashify:SingleValueString',
  title: 'Single Value String',
  owner: 'System',
  solution: '',
  tags: ['widget', 'numeric', 'single value', 'string'],
  createdAt: 'Aug 20, 2023, 10:14 AM',
  modifiedAt: 'AUG 20, 2023, 2:34 PM',
  spec: {
    props: {
      title: '',
      data: '--',
      unit: '',

      href: '',
      valueTextSize: 'text-2xl',
      titleTextSize: 'text-2xl',
      subTitleTextSize: 'text-xs',
      alignment: 'LEFT',
      backgroundColorClassName: '',
      titleColorClassName: '',
      valueColorClassName: '',
      drillDownHoverColorClassName: 'hover:bg-neutral-200/20',
      unitColorClassName: '',
    },
    title: '/${ props.title }',
    value: '/${ props.shortFormat ? $toNumberShort(props.data) : props.data }',
    unit: '/${ props.unit }',
    href: '/${ props.href }',

    alignmentClassNames: {
      LEFT: 'items-start',
      CENTER: 'items-center',
      RIGHT: 'items-end',
    },
    alignment: '/${ $uppercase(props.alignment) }',
    alignmentClassName: '/${ $lookup(alignmentClassNames, alignment) }',
    backgroundColorClassName: '/${ props.backgroundColorClassName }',
    titleColorClassName: '/${ props.titleColorClassName }',
    valueColorClassName: '/${ props.valueColorClassName }',
    drillDownHoverColorClassName: '/${ props.drillDownHoverColorClassName }',
    unitColorClassName: '/${ props.unitColorClassName }',

    containerClassName:
      "/${ 'text-sm px-3 mx-2 flex flex-col justify-center ' & backgroundColorClassName & ' ' & alignmentClassName }",
    titleClassName:
      '/${ "opacity-80 mb-1 whitespace-nowrap overflow-hidden overflow-ellipsis w-[190px] " & titleColorClassName & " " & (props.titleTextSize? props.titleTextSize : "text-2xl")}',
    subTitleClassName:
      '/${ "opacity-80 mb-2 whitespace-nowrap overflow-hidden overflow-ellipsis w-[190px] " & titleColorClassName & " " & (props.subTitleTextSize ? props.subTitleTextSize : "text-2xl")}',
    valueClassName:
      "/${ 'm-0 flex items-baseline ' & valueColorClassName & ' ' & (props.valueTextSize? props.valueTextSize : 'text-2xl') }",
    drillDownClassName: '/${ drillDownHoverColorClassName }',
    unitClassName: "/${ 'text-md mx-1 whitespace-nowrap overflow-hidden overflow-ellipsis w-[190px] ' & unitColorClassName }",

    view: [
      {
        instanceOf: 'div',
        className: '/${ containerClassName }',
        children: [
          {
            instanceOf: 'p',
            className: 'text-info-bg opacity-80 text-xs text-right',
            children: '/${ props.miniTitle }',
          },
          {
            instanceOf: 'p',
            className: '/${ titleClassName }',
            children: '/${ title }',
          },
          {
            instanceOf: 'div',
            className: '/${ valueClassName }',
            children: [
              {
                instanceOf: 'a',
                href: '/${ href }',
                className: '/${ href ? drillDownClassName : "pointer-events-none" }',
                children: [
                  {
                    instanceOf: 'p',
                    className: '/${ valueClassName }',
                    children: '/${ value }',
                  },
                ],
              },
              {
                instanceOf: 'p',
                className: '/${ unit ? unitClassName : "hidden" }',
                children: '/${ value = "--" ? "" : unit }',
              },
            ],
          },
          {
            instanceOf: 'p',
            className: '/${ subTitleClassName }',
            children: '/${ props.subTitle }',
          },
        ],
      },
    ],
  },
};
